import React from 'react';
import { Flex } from 'antd';

import { HelpSection } from '../../features/CustomerSupport';
import { usePrerenderUser } from '../../hooks/usePrerenderUser';
import { NotificationsPreviewWidget } from '../../features/NotificationsCenter';
import { Walkthrough } from '~features/FreeTrial';
import { RenderCounter } from './RenderCounter';
import AccountDropdown from './AccountDropdown';
import DebugMenu from './DebugMenu';

const NavigationTopbar = ({ navigationLocked = false }) => {
  const { updateAvailableTargets } = Walkthrough.useWalkthroughTargets();

  const user = usePrerenderUser();
  const eventsTrackingData = {
    userId: user.id,
    userEmail: user.email,
    companyId: user.companyId,
    companyName: user.companyName,
  };

  const handleRef = React.useCallback((node) => updateAvailableTargets('render-counter', !!node), []);

  return (
    <>
      <Flex align="center" justify={'flex-end'} flex={1}>
        <Flex align="center" gap="small">
          <DebugMenu />
          <HelpSection eventsTrackingData={eventsTrackingData} />
          {!navigationLocked && <NotificationsPreviewWidget />}
          {!navigationLocked && (
            <div ref={handleRef} id="render-counter">
              <RenderCounter />
            </div>
          )}
          <AccountDropdown hideLinks={navigationLocked} />
        </Flex>
      </Flex>
    </>
  );
};

export default NavigationTopbar;
